import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { MailAccount } from "../../comunications/_types/mail-account";

export enum ContractsOutgoingMailResourceType {
    PhotoReport = "PhotoReport", //Informe fotografico
    Invoice = "Invoice", //Factura
    IncomingInvoice = "IncomingInvoice", //autofactura
    Budget = "Budget", //presupuesto
    Other = "Other" //otros
}

export class ContractOutgoingMail extends Resource {
    public override type = 'contractOutgoingMails';

    @prop()
    @required()
    public contractId!: string;


    @prop()
    public outgoingMailResourceType: ContractsOutgoingMailResourceType = ContractsOutgoingMailResourceType.Other;

    @prop()
    @required()
    public mailAccountId!: string;

    @prop()
    public mailAccount!: MailAccount;

    @prop()
    public mailTo!: string;
}